// number spinner directive
//
//   <number-spinner ng-model="vm.myNumber"
//                   min-value="0"
//                   max-value="100" />

let module = angular.module('app.directives');

module.directive('numberSpinner', ($timeout) => {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      ngModel: '=',
      minValue: '=',
      maxValue: '=',
      ngChange: '@',
      size: '@',
      width: '@',
    },
    require: 'ngModel',
    template: `
      <div class="input-group" style="width:{{width}}; margin:0 auto;">
        <div class="input-group-btn">
          <button class="btn btn-default btn-{{size}}"
                  style="padding-left:10px;padding-right:10px"
                  ng-click="decrement()"
                  tabindex="-1">
            <i class="fa fa-minus" style="color: #999"></i>
          </button>
        </div>
        <input type="text"
               class="form-control input-{{size}}"
               style="min-width:20px; padding-left:0; padding-right:0; text-align:center;"
               ng-model="ngModel"
               onclick="this.setSelectionRange(0, this.value.length)">
        <div class="input-group-btn">
          <button class="btn btn-default btn-{{size}}"
                  style="padding-left:10px;padding-right:10px"
                  ng-click="increment()"
                  tabindex="-1">
            <i class="fa fa-plus" style="color: #999"></i>
          </button>
        </div>
      </div>
      <!--
      <a href="javascript://"
         ng-click="decrement()"><i class="fa fa-minus-square"></i></a>
      <span style="border:1px solid #aaa; padding:0 10px;">{{ngModel}}</span>
      <a href="javascript://"
         ng-click="increment()"><i class="fa fa-plus-square"></i></a>
      -->
    `,
    link: (scope, element, attrs, ngModelCtrl) => {
      scope.minValue = typeof scope.minValue == 'undefined' ? 0 : scope.minValue;
      scope.maxValue = typeof scope.maxValue == 'undefined' ? 999 : scope.maxValue;

      if (attrs.ngChange) {
        ngModelCtrl.$viewChangeListeners.push(function () {
          scope.$eval(attrs.ngChange);
        });
      }

      scope.decrement = () => {
        let newValue = ngModelCtrl.$modelValue - 1;
        update(isNaN(newValue) ? scope.minValue : newValue);
      };

      scope.increment = () => {
        let newValue = ngModelCtrl.$modelValue + 1;
        update(isNaN(newValue) ? scope.minValue : newValue);
      };

      element.find('input.form-control').on('change', function () {
        $timeout(() => update($(this).val()));
      });

      function update(value) {
        if (value === '' || value === null) {
          value = ''; //empty string is a valid state that shouldn't be coerced to 0
        } else {
          value = parseInt(value, 10);
          if (value > scope.maxValue) value = scope.maxValue;
          if (isNaN(value) || value < scope.minValue) value = scope.minValue;
        }
        scope.ngModel = value;
        ngModelCtrl.$setViewValue(value);
        ngModelCtrl.$commitViewValue();
        if (scope.onChange) {
          scope.onChange(value);
        }
      }

      scope.$watch('ngModel', (newValue) => {
        if (isNaN(ngModelCtrl.$modelValue)) {
          scope.increment(); // reset to min value if not defined
        }
      });
    },
  };
});



// WEBPACK FOOTER //
// ./app/directives/number-spinner.js